import { OwnerInfo } from '../types';

// 로컬스토리지 키 상수
const STORAGE_KEYS = {
  OWNER_ID: 'ownerId',
  NAME: 'name',
  PHONE: 'phone',
} as const;

// ownerId 가져오기
export const getStoredOwnerId = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.OWNER_ID);
  } catch (error) {
    console.error('Failed to get ownerId from localStorage:', error);
    return null;
  }
};

// ownerName 가져오기
export const getStoredOwnerName = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.NAME);
  } catch (error) {
    console.error('Failed to get owner name from localStorage:', error);
    return null;
  }
};

// ownerPhone 가져오기
export const getStoredOwnerPhone = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.PHONE);
  } catch (error) {
    console.error('Failed to get owner phone from localStorage:', error);
    return null;
  }
};

// ownerId 저장하기
export const storeOwnerId = (ownerId: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.OWNER_ID, ownerId);
  } catch (error) {
    console.error('Failed to store ownerId in localStorage:', error);
  }
};

// ownerName 저장하기
export const storeOwnerName = (name: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.NAME, name);
  } catch (error) {
    console.error('Failed to store owner name in localStorage:', error);
  }
};

// ownerPhone 저장하기
export const storeOwnerPhone = (phone: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.PHONE, phone);
  } catch (error) {
    console.error('Failed to store owner phone in localStorage:', error);
  }
};

// Owner 정보 한번에 저장하기 (개선된 버전)
export const storeOwnerInfo = (ownerId: string, name: string, phone: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.OWNER_ID, ownerId);
    localStorage.setItem(STORAGE_KEYS.NAME, name);
    localStorage.setItem(STORAGE_KEYS.PHONE, phone);
  } catch (error) {
    console.error('Failed to store owner info in localStorage:', error);
  }
};

// Owner 정보 객체로 저장하기 (새로운 메서드)
export const storeOwnerInfoObject = (ownerInfo: OwnerInfo): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.OWNER_ID, ownerInfo.ownerId);
    localStorage.setItem(STORAGE_KEYS.NAME, ownerInfo.name);
    localStorage.setItem(STORAGE_KEYS.PHONE, ownerInfo.phone);
  } catch (error) {
    console.error('Failed to store owner info in localStorage:', error);
  }
};

// Owner 정보 한번에 가져오기 (개선된 버전)
export const getStoredOwnerInfo = (): Partial<OwnerInfo> => {
  return {
    ownerId: getStoredOwnerId() || undefined,
    name: getStoredOwnerName() || undefined,
    phone: getStoredOwnerPhone() || undefined,
  };
};

// 완전한 Owner 정보 가져오기 (모든 필드가 있을 때만 반환)
export const getCompleteOwnerInfo = (): OwnerInfo | null => {
  const ownerId = getStoredOwnerId();
  const name = getStoredOwnerName();
  const phone = getStoredOwnerPhone();

  if (ownerId && name && phone) {
    return { ownerId, name, phone };
  }
  
  return null;
};

// ownerId 존재 여부 확인
export const hasOwnerId = (): boolean => {
  return getStoredOwnerId() !== null;
};

// ownerName 존재 여부 확인
export const hasOwnerName = (): boolean => {
  return getStoredOwnerName() !== null;
};

// ownerPhone 존재 여부 확인
export const hasOwnerPhone = (): boolean => {
  return getStoredOwnerPhone() !== null;
};

// 완전한 Owner 정보 존재 여부 확인
export const hasCompleteOwnerInfo = (): boolean => {
  return hasOwnerId() && hasOwnerName() && hasOwnerPhone();
};

// Owner 정보 전체 삭제
export const clearOwnerInfo = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEYS.OWNER_ID);
    localStorage.removeItem(STORAGE_KEYS.NAME);
    localStorage.removeItem(STORAGE_KEYS.PHONE);
  } catch (error) {
    console.error('Failed to clear owner info from localStorage:', error);
  }
};
